import qs from "query-string";
import { AttendanceDTO, StudentDTO, StudentWithAttendanceDTO } from "src/dto";
import { util } from "src/utils";

class AdapterService {
  // 서버로부터
  to = {
    enter(student: StudentWithAttendanceDTO): req.AttendanceEnter {
      return {
        studentIdList: [student.id],
        datetime: new Date(new Date().getTime() + 9 * 60 * 60 * 1000),
        sentForParent: !!student.parent.phone,
      };
    },
    quit(student: StudentWithAttendanceDTO): req.AttendanceQuit {
      return {
        idList: [student.attendanceId!],
        datetime: new Date(new Date().getTime() + 9 * 60 * 60 * 1000),
        sentForParent: !!student.parent.phone,
      };
    },
    // 서버가 로그인 학원 단위로 조회한다. 학생 ID 를 쿼리에 실으면 학생 수만큼
    // URL 이 길어져, 대형 학원에서 요청 라인+헤더 크기 한도를 넘어 400 으로 거부된다.
    todayAttendances: () => {
      return qs.stringify({
        startDate: util.getStringToday(),
        endDate: util.getStringToday(),
      });
    },
  };

  // 서버쪽으로
  from = {
    studentWithAttendance: (student: StudentDTO) => {
      return {
        ...student,
        enterDatetime: null,
        quitDatetime: null,
        attendanceStatus:
          "QUIT" as StudentWithAttendanceDTO["attendanceStatus"],
        attendanceId: null,
      };
    },
    attendanceInfo: (response: AttendanceDTO[]) => {
      const [{ enterDatetime, quitDatetime, status, id }] = response;
      return {
        enterDatetime,
        quitDatetime,
        status,
        id,
      };
    },
  };
}

export default AdapterService;
